import { useEffect } from 'react'
import { openDocument, openFromPicker } from '@/lib/commands'
import { readFile } from '@/lib/files'

interface LaunchParams {
  files: FileSystemFileHandle[]
}
declare global {
  interface Window {
    launchQueue?: { setConsumer(cb: (p: LaunchParams) => void): void }
  }
}

/**
 * Opens files handed to the installed PWA by the OS ("Open with Folio", file_handlers),
 * files shared to it on Android (share_target), and the ?action=open shortcut.
 */
export function useFileLaunch() {
  useEffect(() => {
    window.launchQueue?.setConsumer(async ({ files }) => {
      const handle = files?.[0]
      if (!handle) return
      const file = await handle.getFile()
      await openDocument(await readFile(file), file.name, handle)
    })

    const url = new URL(location.href)
    if (url.searchParams.has('shared')) {
      // The service worker stashed the shared file in the cache.
      ;(async () => {
        try {
          const cache = await caches.open('folio-share-target')
          const res = await cache.match('/shared-file')
          if (res) {
            const name = decodeURIComponent(res.headers.get('x-file-name') ?? 'Shared.pdf')
            await openDocument(new Uint8Array(await res.arrayBuffer()), name)
            await cache.delete('/shared-file')
          }
        } catch (e) {
          console.warn(e)
        }
      })()
    }
    if (url.searchParams.get('action') === 'open') setTimeout(() => void openFromPicker(), 300)
    if (url.search) history.replaceState(null, '', url.pathname)
  }, [])
}
